import { createContext, ReactNode, useContext, useState } from 'react';

interface SidebarContentProps {
    open: boolean;
    setOpen: (open: boolean) => void;
}

export const SidebarContext = createContext<SidebarContentProps | undefined>(undefined);

interface Props {
    readonly children: ReactNode;
}

export function SidebarProvider({ children }: Props) {

    const [open, setOpen] = useState(false);

    return <SidebarContext.Provider value={{ open, setOpen }}>
        {children}
    </SidebarContext.Provider>;
}

export function useSidebar() {
    const context = useContext(SidebarContext);

    if (!context) {
        throw new Error();
    }

    return context;
}
